export default "__VITE_ASSET__BQvINToM__"